<section class="bolt-container bolt-space-inner-2xl bolt-background-ultralightGray">
    <bolt-waiting-indicator class="bolt-space-inner-xl"
        *ngIf="isLoading"></bolt-waiting-indicator>
    <div *ngIf="!isLoading">
        <div class="bolt-body-md bolt-space-bottom-sm"><strong>What’s happening with your claim?</strong></div>
        <div class="bolt-subheading-lg bolt-space-bottom-xs"><strong>{{stepDescription}}</strong></div>
        <a href="#"
            class="bolt-link bolt-body-md bolt-space-bottom-2xl"
            (click)="$event.preventDefault(); goToSupportTab()">Learn about the claim process<bolt-icon class="bolt-space-left-2xs" name="arrow-right" size="sm"></bolt-icon></a>
        <div *ngIf="hasTimeline"
            class="bolt-row bolt-space-bottom-sm bolt-justify-content-center">
            <div class="stepper">
                <div class="step"
                    *ngFor="let step of filteredSteps; let i = index"
                    [ngClass]="step.status">
                    <div>
                        <bolt-icon title="Completed"
                            *ngIf="step.status === 'COMPLETE'"
                            color="theme-success"
                            name="checkmark-bold-circle-filled">
                        </bolt-icon>

                        <img *ngIf="step.status === 'IN_PROGRESS'"
                            src="assets/icons/in-progress-circle.svg"
                            alt="In Progress"
                            width="27"
                            height="27">

                        <bolt-icon title="Upcoming"
                            *ngIf="step.status === 'NOT_STARTED'"
                            name="empty-circle">
                        </bolt-icon>

                        <img *ngIf="step.status === 'NOT_APPLICABLE'"
                            src="assets/icons/not-applicable-circle.svg"
                            alt="None for this claim"
                            width="27"
                            height="27">
                    </div>

                    <div class="mobile-only step-label bolt-theme-onSurface"
                        [ngClass]="getLabelCss(i)">{{ step.mobileLabel }}</div>
                    <div class="desktop-only step-label bolt-theme-onSurface"
                        [ngClass]="getLabelCss(i)">{{ step.label }}</div>

                    <div class="line"
                        *ngIf="i < filteredSteps.length - 1"
                        [ngClass]="{
                                                'solid': filteredSteps[i+1].status !== 'NOT_STARTED',
                                                'dashed': filteredSteps[i+1].status === 'NOT_STARTED'
                                                }"></div>
                </div>
            </div>
        </div>

        <bolt-notification *ngIf="!hasTimeline"
            type="error">
            <div class="bolt-body-copy-lg">Your claim timeline didn't load. We'll get it fixed.</div>
        </bolt-notification>
    </div>
</section>
